<template>
	<div>
		<li v-if="!['PLATINUM COUPLE','PLATINUM FAITHFUL','FREE'].includes($page.props.user.current_rank)" class="d-none upgrade-plandetails-hidden px-4 text-center">
			<inertia-link href="/member/upgrade" class="btn btn-danger px-7" data-toggle="layout" data-action="sidebar_close">
				<i class="nav-main-link-icon fa fa-arrow-circle-up me-2"></i><span>Upgrade</span>
			</inertia-link>
		</li>
		<li class="nav-main-heading d-none upgrade-plandetails-hidden text-center">
			<inertia-link href="/member/plan-details" class="text-success">
				<i class="nav-main-link-icon fa fa-fw fa-list"></i> <span>Plan Details</span>
			</inertia-link>
		</li>

		<li class="nav-main-heading">Navigations</li>
		<!-- Start sidebar link -->
		<sidebar-link :sidebar-menus="sidebarMenus" />
		<!-- <li v-if="(user.has_bcc || user.current_rank === 'BCC') && user.bcc_expiry>=$page.props.dateToday" class="nav-main-heading">Blockchain Circle (BCC)</li>
		<li
			v-if="(user.has_bcc || user.current_rank === 'BCC') && user.bcc_expiry>=$page.props.dateToday"
			class="nav-main-item"
		>
			<a
				:href="route('member.bcc.home')"
				class="nav-main-link"
				data-bs-placement="bottom"
				title="Visit BCC Home"
			>
				<i class="nav-main-link-icon fa fa-home"></i>
				<span class="nav-main-link-name">BCC Home</span>
			</a>
		</li> -->
		<!-- <li v-else class="nav-main-item">
			<inertia-link
				:href="route('member.bcc-subscribe')"
				class="nav-main-link"
				data-bs-placement="bottom"
				title="Add BCC to your subscription"
				:class="{ active: $page.component === 'Member/AddBCC' }"
			>
				<i class="nav-main-link-icon fa fa-plus"></i>
				<span class="nav-main-link-name">Subscribe BCC</span>
			</inertia-link>
		</li> -->
		<li
			v-if="user.current_rank=='FREE'"
			class="nav-main-item"
		>
			<inertia-link
				:href="route('member.home-free')"
				class="nav-main-link"
				data-bs-placement="bottom"
				title="Member Home"
				:class="{ active: $page.component === 'Member/HomeFree' }"
			>
				<i class="nav-main-link-icon fa fa-home"></i>
				<span class="nav-main-link-name">Home</span>
			</inertia-link>
		</li>
		<li
			v-if="user.addons['TRC COUPLE']"
			class="nav-main-item"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i :class="'nav-main-link-icon fa fa-users'"></i>
				<span class="nav-main-link-name">TRC Couple</span>
			</a>
			<ul class="nav-main-submenu">
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component == 'Member/TRCCouple/CoupleHome' }"
						:href="route('member.trc-couple.home')"
					>
						<span class="nav-main-link-name">Home</span>
					</inertia-link>
				</li>
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component == 'Member/TRCCouple/CoupleContents' }"
						:href="route('member.trc-couple.contents')"
					>
						<span class="nav-main-link-name">Contents</span>
					</inertia-link>
				</li>
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component.startsWith('Member/TRCCouple/CoupleBlog') }"
						:href="route('member.trc-couple.blogs')"
					>
						<span class="nav-main-link-name">Blogs</span>
					</inertia-link>
				</li>
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component == 'Member/TRCCouple/CouplePlanDetails' }"
						:href="route('member.trc-couple.plan-details')"
					>
						<span class="nav-main-link-name">Plan Details</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li v-else class="nav-main-item">
			<inertia-link
				:href="route('member.trc-couple.join')"
				class="nav-main-link"
				data-bs-placement="bottom"
				title="Add TRC Couple"
				:class="{ active: $page.component === 'Member/TRCCouple/JoinCouple' }"
			>
				<i class="nav-main-link-icon fa fa-plus"></i>
				<span class="nav-main-link-name">Join TRC Couple</span>
			</inertia-link>
		</li>
		<li
			v-if="user.addons['TRC AI CIRCLE']"
			class="nav-main-item"
		>
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i :class="'nav-main-link-icon fa fa-user-astronaut'"></i>
				<span class="nav-main-link-name">TRC AI Circle</span>
			</a>
			<ul class="nav-main-submenu">
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component == 'Member/TRCAiCircle/AiCircleHome' }"
						:href="route('member.trc-ai-circle.home')"
					>
						<span class="nav-main-link-name">Home</span>
					</inertia-link>
				</li>
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component.startsWith('Member/TRCAiCircle/AiCircleBlog') }"
						:href="route('member.trc-ai-circle.latest-updates')"
					>
						<span class="nav-main-link-name">Latest Updates</span>
					</inertia-link>
				</li>
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component == 'Member/TRCAiCircle/AiCirclePlanDetails' }"
						:href="route('member.trc-ai-circle.plan-details')"
					>
						<span class="nav-main-link-name">Plan Details</span>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li v-else class="nav-main-item">
			<inertia-link
				:href="route('member.trc-ai-circle.join')"
				class="nav-main-link"
				data-bs-placement="bottom"
				title="Add TRC AI Circle"
				:class="{ active: $page.component === 'Member/TRCAiCircle/JoinAiCircle' }"
			>
				<i class="nav-main-link-icon fa fa-plus"></i>
				<span class="nav-main-link-name">Join TRC AI Circle</span>
			</inertia-link>
		</li>
		<li v-if="user.current_rank=='FREE'" class="nav-main-item">
			<inertia-link
				:href="route('member.join-gold')"
				class="nav-main-link"
				data-bs-placement="bottom"
				title="Join TRC Gold Member"
				:class="{ active: $page.component === 'Member/JoinGoldMember' }"
			>
				<i class="nav-main-link-icon fa fa-plus"></i>
				<span class="nav-main-link-name">Join TRC Gold Member</span>
			</inertia-link>
		</li>
	</div>
</template>

<script>
// import { onMounted } from '@vue/runtime-core'
import { onMounted } from 'vue';
import SidebarLink from '../../../Components/Member/SidebarLink';

export default {
	props: {
		user 		: Object,
		userRole 	: String,
		sidebarMenus: Object,
	},
	components: {
		SidebarLink,
	},
	setup(props) {
		onMounted(() => {
			const activeLink = document.getElementsByClassName('submenu active')[0]
			if (activeLink) {
				const activeLinkParent =
					activeLink.parentElement.parentElement.parentElement
				activeLinkParent.classList.add('open')
			}
		})

	},
}
</script>
